import * as utils from './Utils';

export function requireCookieConsent() {
  if (!window.OnVoardData.use_cookie_consent) return false;
  if (!document.querySelector(".cookie-permission-container")) return false;
  return true;
}

export function allowCookieId() {
  if (!requireCookieConsent()) return true;

  let allow = utils.getCookie('ov_allow_cookie_id');
  if (allow) return true;
  return false;
}

export function allowContactIdCookie() {
  if (!requireCookieConsent()) return true;

  let allow = utils.getCookie('ov_allow_contact_id');
  if (allow) return true;
  return false;
}

export function allowBackInStockVisitorIdCookie() {
  return true;
}

export function allowReviewsUpvotedCookie() {
  return true;
}

export function allowPromptSessionCookies() {
  return true;
}

export function allowPromptVisitorIdCookie() {
  return true;
}

export function allowPromptLastSeenCookie() {
  if (!requireCookieConsent()) return true;

  let allow = utils.getCookie('ov_allow_prompt_last_seen');
  if (allow) return true;
  return false;
}
